import { DraftIdentity, DraftTarget } from './DraftManager';
import { nullSafeGet } from './DataAccessUtils';
import { NoteChannel } from '../components/work_order_row_display/work_order_row_note_preview/NoteChannelTag';

const TARGET_BY_CHANNEL: Record<NoteChannel, DraftTarget> = {
	client: 'wo_note:client',
	internal: 'wo_note:internal',
	subcontractor: 'wo_note:subcontractor',
};

export const workOrderNoteDraftTarget = (channel: NoteChannel): DraftTarget =>
	TARGET_BY_CHANNEL[channel];

const REPLY_TARGET_BY_CHANNEL: Record<NoteChannel, DraftTarget> = {
	client: 'wo_note_reply:client',
	internal: 'wo_note_reply:internal',
	subcontractor: 'wo_note_reply:subcontractor',
};

export const workOrderNoteReplyDraftTarget = (channel: NoteChannel): DraftTarget =>
	REPLY_TARGET_BY_CHANNEL[channel];

const buildIdentity = (
	currentUser: any,
	workOrderId: string | number,
	target: DraftTarget
): DraftIdentity | null => {
	const email = nullSafeGet('email', currentUser);
	const facilityId = nullSafeGet('facility.id', currentUser);
	if (!email || !facilityId || !workOrderId || !target) {
		return null;
	}
	return {
		target,
		tenantId: String(facilityId),
		userId: String(email).toLowerCase(),
		entityId: String(workOrderId),
	};
};

export const buildWorkOrderNoteDraftIdentity = (
	currentUser: any,
	workOrderId: string | number,
	channel: NoteChannel
): DraftIdentity | null => buildIdentity(currentUser, workOrderId, workOrderNoteDraftTarget(channel));

export const buildWorkOrderNoteReplyDraftIdentity = (
	currentUser: any,
	workOrderId: string | number,
	channel: NoteChannel
): DraftIdentity | null => buildIdentity(currentUser, workOrderId, workOrderNoteReplyDraftTarget(channel));
